module.exports = __webpack_public_path__ + "media/images/stock/worker-at-desk-13ede3b7260a23bfcd96a40a2b3d4480.jpg";